'use client'

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { match } from 'ts-pattern';
import { excludeProps } from '../../internal/filterProps.mjs';
import { Experimental } from '../../internal/lifecycles.mjs';
import defaultStyled from '../../internal/styled-components.mjs';
import { color } from '../../lib/styles/styles.mjs';

const fontSize = (props) => match(props).with({ size: "l" }, () => "1.125rem").with({ size: "m" }, () => "1rem").with({ size: "s" }, () => "0.875rem").otherwise(() => "inherit");
const lineHeight = (props) => match(props).with({ size: "l" }, () => "1.75rem").with({ size: "m" }, () => "1.5rem").with({ size: "s" }, () => "1.25rem").otherwise(() => "inherit");
const fontWeight = (props) => match(props).with({ bold: true }, () => "bold").with({ bold: false }, () => "normal").exhaustive();
const fontColor = (props) => match(props).with({ color: "inherit" }, () => "inherit").otherwise(() => color("mineshaft700"));
const StyledRoot = defaultStyled.span.withConfig(
  excludeProps(["size", "bold", "color"])
)`
  font-weight: ${fontWeight};
  font-size: ${fontSize};

  color: ${fontColor};

  line-height: ${lineHeight};
`;
const Text = forwardRef(({ bold = false, ...props }, forwardedRef) => {
  return /* @__PURE__ */ jsx(Experimental, { name: "Text", children: /* @__PURE__ */ jsx(
    StyledRoot,
    {
      as: bold ? "strong" : "span",
      bold,
      ...props,
      ref: forwardedRef
    }
  ) });
});
Text.displayName = "Text";

export { Text };
//# sourceMappingURL=Text.mjs.map
